var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5625 10.125L1.49813 13.8675C1.60943 14.3127 2.00941 14.625 2.46828 14.625H14.007C14.3857 14.625 14.732 14.411 14.9014 14.0722L16.875 10.125H15.1875M0.5625 10.125H15.1875M0.5625 10.125L1.6875 7.875M15.1875 10.125L14.3389 8.42779C14.1695 8.089 13.8232 7.875 13.4445 7.875H12.375M1.6875 7.875H12.375M1.6875 7.875V6.625C1.6875 6.07272 2.13522 5.625 2.6875 5.625H2.8125M12.375 7.875L11.5264 6.17779C11.357 5.839 11.0107 5.625 10.632 5.625H7.59375M7.59375 5.625L7.18626 3.99503C7.09516 3.63063 6.76775 3.375 6.39214 3.375V3.375C5.85961 3.375 5.46886 3.87546 5.59802 4.39209L5.90625 5.625M7.59375 5.625H5.90625M5.90625 5.625H4.5M4.5 5.625L4.09251 3.99503C4.00141 3.63063 3.674 3.375 3.29839 3.375V3.375C2.76586 3.375 2.37511 3.87546 2.50427 4.39209L2.8125 5.625M4.5 5.625H2.8125",
    stroke: "#435382",
    strokeWidth: 1.125
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipIcon);
export default __webpack_public_path__ + "static/media/ship-icon.354453a3cb5df595cc22b40d47dfc473.svg";
export { ForwardRef as ReactComponent };